import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { WelcomePopup } from "@/components/WelcomePopup";
import { StickyBookNow } from "@/components/StickyBookNow";
import { ScrollToTop } from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import AccommodationsPage from "@/pages/AccommodationsPage";
import BetCabinPage from "@/pages/BetCabinPage";
import GlampingPage from "@/pages/GlampingPage";
import DomesCabinsPage from "@/pages/DomesCabinsPage";
import CampingPage from "@/pages/CampingPage";
import ExperiencesPage from "@/pages/ExperiencesPage";
import RetreatsPage from "@/pages/RetreatsPage";
import GalleryPage from "@/pages/GalleryPage";
import ReviewsPage from "@/pages/ReviewsPage";
import FAQPage from "@/pages/FAQPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PoliciesPage from "@/pages/PoliciesPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import CartPage from "@/pages/CartPage";
import AdminPage from "@/pages/AdminPage";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <BrowserRouter>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/accommodations" element={<AccommodationsPage />} />
              <Route path="/bet-cabin" element={<BetCabinPage />} />
              <Route path="/glamping" element={<GlampingPage />} />
              <Route path="/domes-cabins" element={<DomesCabinsPage />} />
              <Route path="/camping" element={<CampingPage />} />
              <Route path="/experiences" element={<ExperiencesPage />} />
              <Route path="/retreats" element={<RetreatsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/policies" element={<PoliciesPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
          <StickyBookNow />
          <ChatWidget />
          <WelcomePopup />
        </div>
        <Toaster position="top-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
